<template>
  <v-container>
    <v-form ref="form">
      <v-card class="px-2">
        <input
          id="user-id"
          type="hidden"
          v-model="processo.usuario"
        >
        <input
          id="processo-uuid"
          type="hidden"
          v-model="processo.uuid"
        >
        <input
          id="processo-id"
          type="hidden"
          v-model="processo.id"
        >
        <v-row>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="codigo"
              label="Código"
              dense
              outlined
              @change="loadProcesso()"
            >
              <v-btn
                class="btn-outer-right pa-0"
                slot="append"
                color="success"
                tile
                @click.prevent="loadDialog"
              >
                <v-icon
                  class="mx-0"
                  color="white"
                >
                  mdi-magnify
                </v-icon>
              </v-btn>
            </v-text-field>
          </v-col>
          <v-col
            colls="12"
            lg="3"
            md="6"
            sm="12"
            v-if="!codigo"
          >
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-mask="datacad"
                  v-model="data_cad"
                  label="Data do cadastro.:"
                  dense
                  outlined
                  @blur="mudaDataA"
                >
                  <v-icon
                    slot="append"
                    color="success"
                    large
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-calendar
                  </v-icon>
                </v-text-field>
              </template>
              <v-date-picker
                locale="pt-br"
                v-model="date0"
                @input="dateA"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            md="3"
            lg="2"
            v-if="codigo"
          >
            <v-checkbox
              v-model="processo.inativar"
              label="Inativar processo?"
              color="success"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            colls="12"
            lg="2"
            md="5"
            sm="12"
          >
            <v-text-field
              label="Processo.:"
              v-model="processo.processo"
              required
              dense
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col
            colls="12"
            lg="2"
            md="5"
            sm="12"
          >
            <v-text-field
              label="Ano do processo.:"
              v-model="processo.ano"
              required
              dense
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col
            colls="12"
            lg="3"
            md="4"
            sm="12"
          >
            <v-text-field
              label="Projeto legislativo.:"
              v-model="processo.projeto"
              required
              dense
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col
            colls="12"
            lg="3"
            md="4"
            sm="12"
          >
            <v-text-field
              label="Projeto executivo.:"
              v-model="processo.projeto_executivo"
              required
              dense
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col
            colls="12"
            lg="2"
            md="4"
            sm="12"
          >
            <v-text-field
              label="Ano do projeto.:"
              v-model="processo.ano_projeto"
              required
              dense
              outlined
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-card flat>
          <v-tabs
            background-color="primary"
            dark
            v-model="tabs"
            class="mb-4"
          >
            <v-tab>
              <v-icon class="mr-1">
              </v-icon>
              Geral
            </v-tab>
            <v-tab
              @click="loadAutores"
              :disabled="!processo.id"
            >
              <v-icon class="mr-1">
                mdi-paperclip
              </v-icon>
              + Autores
            </v-tab>
            <v-tab
              @click="loadAnexos"
              :disabled="!processo.id"
            >
              <v-icon class="mr-1">
                mdi-paperclip
              </v-icon>
              Anexos
            </v-tab>
            <v-tab
              @click="loadEmendas"
              :disabled="!processo.id"
            >
              <v-icon class="mr-1">
                mdi-file-sign
              </v-icon>
              Emendas
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <v-card
                flat
                class="py-2"
              >
                <v-row>
                  <v-col
                    colls="12"
                    lg="3"
                    md="6"
                    sm="12"
                  >
                    <v-autocomplete
                      label="Tipo de projeto:"
                      v-model="processo.uid_tipo_projeto"
                      :items="tipoProjeto"
                      clearable
                      dense
                      outlined
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                    lg="2"
                  >
                    <v-autocomplete
                      :disabled="disabled === true"
                      label="Tipo de autor"
                      v-model="processo.tp_autor"
                      :items="autoria"
                      clearable
                      dense
                      outlined
                      @change="loadCaminhoAutor()"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    lg="2"
                  >
                    <v-text-field
                      :disabled="!processo.tp_autor"
                      class="mr-0"
                      v-model="idautor"
                      label="Código 1"
                      dense
                      outlined
                      flat
                      @change="loadAutorPessoa()"
                    >
                      <v-btn
                        class="btn-outer pa-0"
                        slot="append"
                        color="success"
                        tile
                        @click="loadFtAutor"
                      >
                        <v-icon
                          class="mx-0"
                          color="white"
                        >
                          mdi-magnify
                        </v-icon>
                      </v-btn>
                      <v-btn
                        class="btn-outer-right pa-0"
                        slot="append"
                        color="light"
                        tile
                        @click="loadAddPessoa"
                      >
                        <v-icon
                          class="mx-0"
                          color="black"
                        >
                          mdi-plus
                        </v-icon>
                      </v-btn>
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="9"
                    lg="5"
                  >
                    <v-text-field
                      :disabled="!processo.tp_autor"
                      v-model="nmautor"
                      :loading="loading"
                      aria-autocomplete="none"
                      :search-input.sync="search"
                      label="Autoria do projeto 2"
                      outlined
                      dense
                      @keyup.native="loadSeachAutor()"
                    >
                      <v-icon
                        v-if="nmautor"
                        slot="append"
                        color="black"
                        @click.prevent="clPessoa"
                      >
                        mdi-close
                      </v-icon>
                    </v-text-field>
                    <v-card
                      v-show="listarPes === 'sim'"
                      class="my-0 py-0"
                    >
                      <ul class="filtro">
                        <li
                          v-for="item in items"
                          :key="item.id"
                        >
                          <a @click="loadAutorPessoa( item, 'novo' )"> {{ item.vereador }}</a>
                        </li>
                      </ul>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    lg="12"
                  >
                    <v-text-field
                      v-model="processo.titulo"
                      type="text"
                      label="Título"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-2">
                  <v-col colls="12">
                    <v-card class="px-0 mb-2">
                      <v-card-subtitle class="my-0 py-0">Ementa</v-card-subtitle>
                      <ckeditor
                        :editor="editor"
                        v-model="processo.ds_projeto"
                        :config="editorConfig"
                        placeholder="Ementa..."
                      ></ckeditor>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card
                      flat
                      class="py-2"
                    >
                      <v-data-table
                        :headers="headerAutor"
                        :items="autores"
                        :search="search"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadAutor(item, mode='update')"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="loadAutor(item, mode='delete')"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-card-actions class="justify-end">
                        <v-btn
                          color="success"
                          class="ml-1 mb-3"
                          v-if="codigo"
                          @click="loadModalAutor"
                        >
                          <v-icon left>
                            mdi-archive-arrow-up-outline
                          </v-icon>
                          Adicionar
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card
                      flat
                      class="py-2"
                    >
                      <v-data-table
                        :headers="headerAnexo"
                        :items="anexos"
                        :search="search"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadAnexo(item, mode='update')"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="loadAnexo(item, mode='delete')"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-card-actions class="justify-end">
                        <v-btn
                          color="success"
                          class="ml-1 mb-3"
                          v-if="codigo"
                          @click="loadModalAnexo"
                        >
                          <v-icon left>
                            mdi-archive-arrow-up-outline
                          </v-icon>
                          Adicionar
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card
                      flat
                      class="py-2"
                    >
                      <v-data-table
                        :headers="headerEmenda"
                        :items="emendas"
                        :search="search"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadAnexo(item, mode='update')"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="loadAnexo(item, mode='delete')"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-card-actions class="justify-end">
                        <v-btn
                          color="success"
                          class="ml-1 mb-3"
                          v-if="codigo"
                          @click="loadDialogEmenda"
                        >
                          <v-icon left>
                            mdi-file-sign
                          </v-icon>
                          Adicionar
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
          <v-card-actions>
            <v-row class="mt-1">
              <v-col
                cols="12"
                md="6"
              >
                <v-btn
                  color="success"
                  class="ml-1 mr-4"
                  v-if="mode === 'save'"
                  @click.prevent="save"
                >
                  <v-icon left>
                    mdi-content-save-outline
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  color="success"
                  class="ml-1 mr-4"
                  v-if="mode === 'update'"
                  @click.prevent="save"
                >
                  <v-icon left>
                    mdi-content-save-edit-outline
                  </v-icon>
                  Atualizar
                </v-btn>
                <v-btn
                  color="secondary"
                  class="mr-4"
                  @click="reset"
                >
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                  Limpar
                </v-btn>
                <v-btn
                  v-if="processo.id"
                  color="error"
                  class="mr-4"
                  @click="remove"
                >
                  <v-icon left>
                    mdi-trash-can-outline
                  </v-icon>
                  Deletar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
        <v-container>
          <v-dialog
            v-model="dialogFilter"
            transition="dialog-bottom-transition"
            fullscreen
          >
            <template v-slot:default="dialogFilter">
              <v-card>
                <v-toolbar
                  color="primary"
                  dark
                >
                  Pesquisar
                </v-toolbar>
                <v-card-title>
                  <v-text-field
                    class="search"
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar"
                    single-line
                    hide-details
                  >
                  </v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="headersProc"
                  :items="processos"
                  :search="search"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      large
                      color="success"
                      class="mr-2"
                      @click.prevent="loadProcesso(item, mode='update')"
                    >
                      mdi-arrow-down-bold-box
                    </v-icon>
                  </template>
                </v-data-table>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="error"
                    @click="dialogFilter.value = false"
                  >Fechar</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-container>
        <!-- Dialog dos autores ou interessados -->
        <v-container>
          <v-dialog
            v-model="DialogAutor"
            transition="dialog-top-transition"
          >
            <v-card
              tile
              min-height="500"
            >
              <v-toolbar
                color="primary"
                dark
                class="mb-2"
              >
                Adicionar ou editar autores ou interessaados ao processo
              </v-toolbar>
              <div class="logo-foto ml-4 mt-5">
                <v-form>
                  <input
                    id="user-id"
                    type="hidden"
                    v-model="autor.usuario"
                  />
                  <input
                    id="uid_processo"
                    type="hidden"
                    v-model="autor.uid_processo"
                  />
                  <input
                    id="autor-id"
                    type="hidden"
                    v-model="autor.id"
                  />
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="codigo"
                        label="Código"
                        dense
                        outlined
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      colls="12"
                      lg="3"
                      md="4"
                      v-if="autor.id"
                    >
                      <v-checkbox
                        v-model="autor.inativar"
                        label="Inativar pessoa?"
                        color="success"
                        class="mt-4"
                      >
                      </v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="3"
                      lg="2"
                    >
                      <v-text-field
                        v-model="autor.uid_pessoa"
                        label="Código..."
                        dense
                        outlined
                        flat
                        @change="loadAutorSel()"
                      >
                        <v-btn
                          class="btn-outer pa-0"
                          slot="append"
                          color="success"
                          tile
                          @click="loadFtAutor"
                        >
                          <v-icon
                            class="mx-0"
                            color="white"
                          >
                            mdi-magnify
                          </v-icon>
                        </v-btn>
                        <v-btn
                          class="btn-outer-right pa-0"
                          slot="append"
                          color="light"
                          tile
                          @click="loadAddPessoa"
                        >
                          <v-icon
                            class="mx-0"
                            color="black"
                          >
                            mdi-plus
                          </v-icon>
                        </v-btn>
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                      lg="5"
                    >
                      <v-text-field
                        v-model="autor.autor"
                        :loading="loading"
                        aria-autocomplete="none"
                        :search-input.sync="search"
                        label="Autor ou interessado"
                        outlined
                        dense
                        @keyup.native="loadSeach()"
                      >
                        <v-icon
                          v-if="autor.autor"
                          slot="append"
                          color="black"
                          @click.prevent="clPessoa"
                        >
                          mdi-close
                        </v-icon>
                      </v-text-field>
                      <v-card
                        v-show="listarAut === 'sim'"
                        class="my-0 py-0"
                      >
                        <ul class="filtro">
                          <li
                            v-for="item in items"
                            :key="item.id"
                          >
                            <a @click="loadAutorSel( item, 'novo' )"> {{ item.vereador }}</a>
                          </li>
                        </ul>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="10"
                      lg="7"
                      class="mx-1 px-1"
                    >
                      <v-text-field
                        v-model="autor.nome"
                        label="Vereador"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-end">
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="autor.id"
                  type="submit"
                  @click.prevent="saveAutor()"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Atualizar
                </v-btn>
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="!autor.id"
                  type="submit"
                  @click.prevent="saveAutor()"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  color="error"
                  class="mr-4"
                  v-if="autor.id"
                  @click="clearAutor"
                >
                  Limpar
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="FecharDialog"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-container>
        <!-- Dialog de anexo -->
        <v-container>
          <v-dialog
            v-model="DialogAnexo"
            transition="dialog-top-transition"
            persistent
          >
            <v-card tile>
              <v-toolbar
                color="primary"
                dark
                class="mb-2"
              >
                Adicionar ou editar anexos ao processo
              </v-toolbar>
              <div class="logo-foto ml-4 mt-5">
                <v-form>
                  <input
                    id="user-id"
                    type="hidden"
                    v-model="anexo.usuario"
                  />
                  <input
                    id="uuid-id"
                    type="hidden"
                    v-model="anexo.uuid"
                  />
                  <input
                    id="anexo-id"
                    type="hidden"
                    v-model="anexo.id"
                  />
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="codigo"
                        label="Código"
                        dense
                        outlined
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      colls="12"
                      lg="3"
                      md="4"
                      v-if="anexo.id"
                    >
                      <v-checkbox
                        v-model="anexo.inativar"
                        label="Inativar Documento?"
                        color="success"
                        class="mt-4"
                      >
                      </v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                      lg="3"
                    >
                      <v-text-field
                        v-model="anexo.nome"
                        type="text"
                        label="Nome do arquivo"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      colls="12"
                      lg="3"
                      md="4"
                    >
                      <v-autocomplete
                        label="Tipo de documento:"
                        v-model="anexo.uid_tipodoc"
                        :items="tipoAnexo"
                        dense
                        outlined
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="5"
                      lg="4"
                    >
                      <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-mask="datanex"
                            v-model="data_anex"
                            label="Data de publicacao.:"
                            dense
                            outlined
                            @blur="mudaDataC"
                          >
                            <v-icon
                              slot="append"
                              color="success"
                              large
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-calendar
                            </v-icon>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          locale="pt-br"
                          v-model="date2"
                          @input="dateC"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row v-if="anexo.id">
                    <v-col
                      cols="12"
                      lg="8"
                    >
                      <v-text-field
                        v-model="anexo.url"
                        label="Limk do documento ou arquivo:"
                        class="mb-2"
                        :readonly="mode === 'delete'"
                        dense
                        outlined
                      >
                        <v-btn
                          icon
                          tile
                          color="success"
                          :href="anexo.url"
                          target="_blank"
                          append
                          slot="append"
                        >
                          <v-icon large>
                            mdi-file-download
                          </v-icon>
                        </v-btn>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="!anexo.id">
                    <input
                      accept="application/vnd.ms-excel, application/pdf"
                      prepend-icon="mdi-paperclip-plus"
                      label="Anexo"
                      v-if="uploadReady"
                      type="file"
                      ref="file"
                      @change="selectFile()"
                    >
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-end">
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="anexo.id"
                  type="submit"
                  @click.prevent="updateDoc()"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Atualizar
                </v-btn>
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="!anexo.id"
                  type="submit"
                  @click.prevent="fileUpload()"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  color="error"
                  class="mr-4"
                  v-if="!anexo.id"
                  @click="clearUpload"
                >
                  deleter
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="FecharDialog"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-container>
        <!-- Dialog de adicionar emenda -->
        <v-container>
          <v-dialog
            v-model="DialogEmenda"
            transition="dialog-top-transition"
            persistent
          >
            <v-card tile>
              <v-toolbar
                color="primary"
                dark
                class="mb-2"
              >
                Adicionar ou editar emendas ao processo
              </v-toolbar>
              <div class="logo-foto ml-4 mt-5">
                <v-form>
                  <input
                    id="user-id"
                    type="hidden"
                    v-model="emenda.usuario"
                  />
                  <input
                    id="uuid-id"
                    type="hidden"
                    v-model="emenda.uuid"
                  />
                  <input
                    id="uid-projeto"
                    type="hidden"
                    v-model="emenda.uid_projeto"
                  />
                  <input
                    id="emenda-id"
                    type="hidden"
                    v-model="emenda.id"
                  />
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="codigo"
                        label="Código"
                        dense
                        outlined
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      colls="12"
                      lg="2"
                      md="3"
                    >
                      <v-menu
                        v-model="menu3"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-mask="dataemenda"
                            v-model="data_emenda"
                            label="Data da emenda.:"
                            dense
                            outlined
                            @blur="mudaDataD"
                          >
                            <v-icon
                              slot="append"
                              color="success"
                              large
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-calendar
                            </v-icon>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          locale="pt-br"
                          v-model="date3"
                          @input="dateD"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col
                      colls="12"
                      lg="3"
                      md="4"
                      v-if="emenda.id"
                    >
                      <v-checkbox
                        v-model="emenda.inativar"
                        label="Inativar Emenda?"
                        color="success"
                        class="mt-4"
                      >
                      </v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="emenda.nr_emenda"
                        type="text"
                        label="Emenda"
                        outlined
                        dense
                        @change="loadTituloEmenda"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="emenda.ano_emenda"
                        type="text"
                        label="Ano da emenda"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="8"
                      lg="8"
                    >
                      <v-text-field
                        v-model="emenda.titulo"
                        type="text"
                        label="Descrição"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-text-field
                        v-model="emenda.autoria"
                        type="text"
                        label="Autoria da emenda"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                      lg="12"
                    >
                      <v-card class="px-0 mb-2">
                        <v-card-subtitle class="my-0 py-0">Justificativa.:</v-card-subtitle>
                        <ckeditor
                          :editor="editor"
                          v-model="emenda.justificativa"
                          :config="editorConfig"
                          placeholder="Ementa..."
                          :readonly="mode === 'delete'"
                        ></ckeditor>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-end">
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="emenda.id"
                  type="submit"
                  @click.prevent="saveEmenda()"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Atualizar
                </v-btn>
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="!emenda.id"
                  type="submit"
                  @click.prevent="saveEmenda()"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="FecharDialog"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-container>
      </v-card>
    </v-form>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
import { baseApiUrl, showError } from '@/global'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'processos',
  computed: mapState(['user']),

  data: function () {
    return {
      errors: {},
      editor: ClassicEditor,
      editorConfig: {
      },
      datacad: '##/##/####',
      datenc: '##/##/####',
      datanex: '##/##/####',
      dataemenda: '##/##/####',
      tabela: 'anexosprocesso',
      mode: 'save',
      cmloadAutor: '',
      idautor: '',
      nmautor: '',
      listarPes: 'não',
      listarAut: 'não',
      tabs: null,
      codigo: '',
      disabled: false,
      dialogFilter: false,
      DialogAnexo: false,
      DialogEmenda: false,
      DialogAutor: false,
      date0: new Date().toISOString().substr(0, 10),
      date1: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      date3: new Date().toISOString().substr(0, 10),
      data_cad: '',
      data_enc: '',
      data_anex: '',
      data_emenda: '',
      menu: false,
      menu1: false,
      menu2: false,
      menu3: false,
      search: null,
      uuid: '',
      uploadReady: true,
      file: '',
      pessoa: {},
      items: [],
      processo: {},
      processos: [],
      anexo: {},
      ordens: [],
      tipoProjeto: [],
      autor: {},
      autores: [],
      anexos: [],
      emenda: {},
      emendas: [],
      tipo: [],
      tipoAnexo: [],
      loading: false,
      filter: null,
      filterOn: [],
      headersProc: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        { text: 'Título', value: 'titulo' },
        { text: 'Processo', value: 'processo' },
        { text: 'Projeto', value: 'projeto' },
        { text: 'Ano', value: 'ano' },
        { text: 'Data', value: 'cadastro' },
        { text: 'Situação', value: 'situacao' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      headerAutor: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        { text: 'Nome de batismo', value: 'autor' },
        { text: 'Vereador', value: 'nome' },
        { text: 'Situação', value: 'situacao' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      headerAnexo: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        { text: 'Nome do arquivo', value: 'nome' },
        { text: 'Url', value: 'url' },
        { text: 'Tamanho', value: 'size' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      headerEmenda: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        { text: 'Nr. emenda', value: 'ne_emenda' },
        { text: 'Título', value: 'titulo' },
        { text: 'Data', value: 'cadastro' },
        { text: 'Autoria', value: 'autoria' },
        { text: 'Situação', value: 'situracao' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      autoria: [
        { value: 'LEG', text: 'Legislativo' },
        { value: 'EXEC', text: 'Executivo' },
        { value: 'PFJ', text: 'Outros' }
      ]
    }
  },
  methods: {
    mudaDataA () {
      const [dia, mes, ano] = this.data_cad.split('/')
      if (this.data_cad) {
        this.processo.data_criacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateA () {
      this.data_cad = moment(this.date0).format('DD/MM/YYYY')
      this.menu = false
      const [dia, mes, ano] = this.data_cad.split('/')
      this.processo.data_criacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataB () {
      const [dia, mes, ano] = this.data_enc.split('/')
      if (this.data_enc) {
        this.processo.data_encerramento = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateB () {
      this.data_enc = moment(this.date1).format('DD/MM/YYYY')
      this.menu1 = false
      const [dia, mes, ano] = this.data_enc.split('/')
      this.processo.data_encerramento = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataC () {
      const [dia, mes, ano] = this.data_anex.split('/')
      if (this.data_anex) {
        this.anexo.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateC () {
      this.data_anex = moment(this.date2).format('DD/MM/YYYY')
      this.menu2 = false
      const [dia, mes, ano] = this.data_anex.split('/')
      this.anexo.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataD () {
      const [dia, mes, ano] = this.data_emenda.split('/')
      if (this.data_emenda) {
        this.emenda.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateD () {
      this.data_emenda = moment(this.date3).format('DD/MM/YYYY')
      this.menu3 = false
      const [dia, mes, ano] = this.data_emenda.split('/')
      this.emenda.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    save () {
      const mode = this.mode
      const method = this.processo.id ? 'put' : 'post'
      const id = this.processo.id ? `/${this.processo.id}` : ''
      axios[method](`${baseApiUrl}/projetos-de-lei${id}`, this.processo)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          if (mode === 'save') {
            this.reset()
          }
        })
        .catch(showError)
    },
    update () {
      const method = this.processo.id ? 'put' : 'post'
      const id = this.processo.id ? `/${this.processo.id}` : ''
      axios[method](`${baseApiUrl}/processo-do-dia-update${id}`, this.processo)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadProcesso()
        })
        .catch(showError)
    },
    updateDoc () {
      const method = this.anexo.id ? 'put' : 'post'
      const id = this.anexo.id ? `/${this.anexo.id}` : ''
      axios[method](`${baseApiUrl}/anexos-de-projetos${id}`, this.anexo)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.clearAnexo()
          this.loadAnexos()
        })
        .catch(showError)
    },
    saveAutor () {
      const method = this.autor.id ? 'put' : 'post'
      const id = this.autor.id ? `/${this.autor.id}` : ''
      axios[method](`${baseApiUrl}/autores${id}`, this.autor)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadAutores()
          if (!id) {
            this.clearAutor()
            this.DialogAutor = false
          }
        })
        .catch(showError)
    },
    saveEmenda () {
      const method = this.emenda.id ? 'put' : 'post'
      const id = this.emenda.id ? `/${this.emenda.id}` : ''
      axios[method](`${baseApiUrl}/emendas${id}`, this.emenda)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadEmendas()
          if (!id) {
            this.clearEmenda()
          }
        })
        .catch(showError)
    },
    remove () {
      if (confirm('Deseja realmente deletar este processo?')) {
      }
    },
    selectFile () {
      this.file = this.$refs.file.files[0]
    },
    async fileUpload () {
      const formData = new FormData()
      const method = this.anexo.id ? 'put' : 'post'
      const id = this.anexo.id ? `/${this.anexo.id}` : ''
      const url = `${baseApiUrl}/upload-documentos-em-anexo-do-projeto${id}`
      formData.append('uid_processo', this.processo.uid_protocolo)
      formData.append('nome', this.anexo.nome)
      formData.append('projeto', this.anexo.projeto)
      formData.append('tabela', this.tabela)
      formData.append('pasta', this.processo.ano)
      formData.append('subpasta', this.processo.uid_protocolo)
      formData.append('uid_tipodoc', this.anexo.uid_tipodoc)
      formData.append('data_publicacao', this.anexo.data_publicacao)
      formData.append('usuario', this.user.id)
      formData.append('file', this.file)
      await axios[method](url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetUpload()
          this.loadAnexos()
        })
        .catch(showError)
    },
    clearUpload () {
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    clearUpCampos () {
      this.file = ''
      this.resetUpload()
      this.clearAnexo()
    },
    resetUpload () {
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    clearAutor () {
      this.autor = {}
    },
    clearEmenda () {
      this.emenda = {}
    },
    deleteAutor () {

    },
    loadCaminhoAutor () {
      const cm = this.processo.tp_autor
      if (cm === 'LEG') {
        this.cmloadAutor = 'vereadores'
      } else if (cm === 'EXEC') {
        this.cmloadAutor = 'gestao'
      } else if (cm === 'PFJ') {
        this.cmloadAutor = 'pessoa'
      } else {
        this.cmloadAutor = ''
      }
    },
    FecharDialog () {
      this.DialogAutor = false
      this.DialogAnexo = false
      this.DialogEmenda = false
      this.anexo = {}
      this.autor = {}
      this.emenda = {}
      this.mode = 'save'
      this.mod = 'save'
      this.listarAut = ''
    },
    clearAnexo () {
      this.anexo = {}
      this.anexo.usuario = this.user.id
      this.anexo.projeto = true
    },
    reset () {
      this.mode = 'save'
      this.codigo = ''
      this.processo = {}
      this.data_cad = ''
      this.data_enc = ''
      this.autores = []
      this.anexos = []
      this.nmautor = ''
      this.idautor = ''
      this.processo.usuario = this.user.id
      this.processo.uuid = uuid.v1()
    },
    loadProcesso (item, mode) {
      const mod = mode || this.mode
      const id = this.codigo ? this.codigo : item.id
      const url = `${baseApiUrl}/projetos-de-lei-update/${id}`
      axios.get(url).then(res => {
        this.processo = res.data
        this.codigo = this.processo.id
        this.idautor = this.processo.uid_autores
        this.nmautor = this.processo.autor
        if (!this.processo.data_criacao) {
          this.data_cad = ''
        } else {
          this.data_cad = moment(this.processo.data_criacao).format('DD/MM/YYYY')
          this.processo.data_criacao = moment(this.processo.data_criacao).format('YYYY-MM-DD')
        }
        //        this.loadAnexos()
      })
      this.mode = mod
      this.dialogFilter = false
      this.loadCaminhoAutor()
    },
    loadAutorPessoa (item) {
      const cm = this.cmloadAutor
      const id = this.idautor ? `/${this.idautor}` : `/${item.id}`
      const url = `${baseApiUrl}/${cm}-selecionado${id}`
      axios.get(url).then(res => {
        this.pessoa = res.data
        this.idautor = this.pessoa.id
        this.nmautor = this.pessoa.vereador
        this.processo.uid_autores = this.idautor
        this.processo.autor = this.nmautor
        this.disabled = true
      })
      this.clPessoa()
    },
    loadAutorSel (item) {
      const cm = this.cmloadAutor
      const id = this.autor.uid_pessoa ? `/${this.autor.uid_pessoa}` : `/${item.id}`
      const url = `${baseApiUrl}/${cm}-selecionado${id}`
      axios.get(url).then(res => {
        this.pessoa = res.data
        this.autor.uid_pessoa = this.pessoa.id
        this.autor.autor = this.pessoa.vereador
        this.autor.nome = this.pessoa.nome
        this.disabled = true
      })
      this.clPessoa()
    },
    clPessoa () {
      this.pessoa = {}
      this.items = []
      this.autor.uid_pessoa = ''
      this.autor.autor = ''
      this.listarAut = ''
      this.listarPes = ''
      this.nmautor = ''
      this.idautor = ''
      this.disabled = false
    },
    clAutor () {
      //  this.items = []
      if (this.nmautor.length < 15) {
        this.nmautor = ''
        this.listarPes = 'não'
      }
    },
    loadAddPessoa () {

    },
    loadFtPessoa () {

    },
    loadFtAutor () {

    },
    loadSeachAutor (listarPes = 'sim') {
      const cm = this.cmloadAutor
      const search = this.nmautor || 0
      const url = `${baseApiUrl}/${cm}-de-projetos/${search}`
      axios.get(url).then(res => {
        this.items = res.data
      })
      this.listarPes = listarPes
    },
    loadSeach (listarAut = 'sim') {
      const cm = this.cmloadAutor
      const search = this.autor.autor || 0
      const url = `${baseApiUrl}/${cm}-de-projetos/${search}`
      axios.get(url).then(res => {
        this.items = res.data
      })
      this.listarAut = listarAut
    },
    loadModalAnexo () {
      this.anexo.usuario = this.user.id
      this.anexo.uuid = uuid.v1()
      this.anexo.projeto = true
      this.DialogAnexo = true
      this.loadTipoAnexo()
    },
    loadDialogEmenda () {
      this.emenda.usuario = this.user.id
      this.emenda.uuid = uuid.v1()
      this.emenda.uid_projeto = this.processo.id
      this.DialogEmenda = true
    },
    loadTituloEmenda () {
      let em = this.emenda.nr_emenda
      if (em) {
        this.emenda.titulo = 'Emenda ' + em + ' ao ' + this.processo.abv_tipo + '-' + this.processo.projeto + '/' + String(this.processo.ano_projeto).substr(-2, 2)
      }
    },
    loadModalAutor () {
      this.autor.usuario = this.user.id
      this.autor.uid_processo = this.processo.id
      this.DialogAutor = true
      this.listarAut = ''
      this.loadCaminhoAutor()
    },
    loadAutor (item, mode) {
      const mod = mode || this.mode
      const id = item.id
      const url = `${baseApiUrl}/autores-update/${id}`
      axios.get(url).then(res => {
        this.autor = res.data
      })
      this.mode = mod
      this.DialogAutor = true
    },
    loadAnexo (items, mode) {
      const id = items.id
      const url = `${baseApiUrl}/anexos-de-projetos-up/${id}`
      axios.get(url).then(res => {
        this.anexo = res.data
        if (!this.anexo.data_publicacao) {
          this.data_anex = ''
        } else {
          this.data_anex = moment(this.anexo.data_publicacao).format('DD/MM/YYYY')
          this.anexo.data_publicacao = moment(this.anexo.data_publicacao).format('YYYY-MM-DD')
        }
      })
      this.mode = mode
      this.DialogAnexo = true
      this.loadTipoAnexo()
    },
    loadDialog () {
      this.dialogFilter = true
      this.loadFilter()
      this.codigo = ''
    },
    loadFilter () {
      const url = `${baseApiUrl}/projetos-de-lei-filtro`
      axios.get(url).then(res => {
        this.processos = res.data.map(item => {
          return {
            ...item,
            cadastro: moment(item.data_criacao).format('DD/MM/YYYY'),
            situacao: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadAnexos () {
      const id = this.processo.uid_protocolo
      const url = `${baseApiUrl}/anexos-de-projetos-por-uid/${id}`
      axios.get(url).then(res => {
        this.anexos = res.data
      })
    },
    loadEmendas () {
      const id = this.processo.id
      const url = `${baseApiUrl}/emendas-por-projeto/${id}`
      axios.get(url).then(res => {
        this.emendas = res.data.map(item => {
          return {
            ...item,
            cadastro: moment(item.data_publicacao).format('DD/MM/YYYY'),
            situacao: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadTipoProjeto () {
      const url = `${baseApiUrl}/tipos-de-projeto`
      axios.get(url).then(res => {
        this.tipoProjeto = res.data.map(item => {
          return {
            value: item.id,
            text: `${item.abv_tipo} - ${item.tipo}`
          }
        })
      })
    },
    loadTipoAnexo () {
      const url = `${baseApiUrl}/categoria-de-documentos`
      axios.get(url).then(res => {
        this.tipoAnexo = res.data.map(item => {
          return {
            value: item.id,
            text: `${item.cat_doc}`
          }
        })
      })
    },
    loadAutores () {
      const id = this.processo.id
      const url = `${baseApiUrl}/autores-por-processo/${id}`
      axios.get(url).then(res => {
        this.autores = res.data.map(item => {
          return {
            ...item,
            situacao: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadUsers () {
      this.processo.usuario = this.user.id
      this.processo.uuid = uuid.v1()
    }
  },
  watch: {
    Filter () {
      // this.loadFilter()
    }
  },
  mounted () {
    this.loadUsers()
    this.loadTipoProjeto()
  }
}
</script>
<style scoped>
.form-tabs {
  background-color: #f0eceaf3;
}
.text-v-card {
  font-size: 1rem !important;
}
.codigo {
  max-width: 100% !important;
}
.v-busca-nome {
  max-width: 100% !important;
  height: 45px !important;
}
.v-input__prepend-outer {
  padding: 0px !important;
  width: 38px !important;
  height: 38px !important;
}
.v-icon-btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
  width: 10px !important;
  height: 38px !important;
  padding: auto !important;
  background-color: teal;
}
.btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
}
.btn-outer-right {
  margin-top: -7px !important;
  margin-right: -11px !important;
}
.v-size--default {
  height: 37px !important;
  min-width: 38px !important;
}
.v-icon-btn {
  margin-top: -7px !important;
  margin-right: -10px !important;
  padding: auto !important;
  background-color: rgb(12, 94, 46);
}
ul.filtro {
  position: absolute;
  min-width: 350px;
  top: 0px;
  left: 40px;
  padding: 2px 6px !important;
  background-color: #feffff;
  border: solid 1px #000;
  list-style: none;
  z-index: 1000;
}
.ftt {
  position: absolute;
  top: 0px;
  left: 40px;
}
ul.filtro li a {
  text-decoration: none;
  color: #333 !important;
}
ul.filtro li:hover {
  background-color: teal;
  color: #ffffff !important;
}
ul.filtro li a:hover {
  color: #ffffff !important;
}
</style>
